module.exports = __webpack_public_path__ + "static/img/order_icon.2ced8b98.png";